module.exports = __webpack_public_path__ + "img/8.0cc5070c.png";